module.exports = __webpack_public_path__ + "static/media/cash.a1b703c0.png";